import { render, staticRenderFns } from "./comprehensive-test.vue?vue&type=template&id=ebd3dddc&scoped=true"
import script from "./comprehensive-test.vue?vue&type=script&lang=js"
export * from "./comprehensive-test.vue?vue&type=script&lang=js"
import style0 from "./comprehensive-test.vue?vue&type=style&index=0&id=ebd3dddc&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebd3dddc",
  null
  
)

export default component.exports